import { BriefingViz } from './BriefingViz';
import { ChipMatrixViz } from './ChipMatrixViz';
import { FishboneViz } from './FishboneViz';
import type { IVisualizationTabProps } from './IVisualizationTabProps';
import { SWOT_LAYOUT } from './swotLayout';
import { TOWS_LAYOUT } from './towsLayout';
import './visualization.css';

/**
 * Вкладка діаграми запису (UIUX views/view-switcher §Visualization tab; прототип v4 tabViz): перша вкладка записів-діаграм —
 * fishbone, матриця SWOT чи TOWS аналізу або брифінг плану інтерв'ю.
 */
export function VisualizationTab({ kind, ...props }: IVisualizationTabProps) {
  if (kind === 'fishbone') return <FishboneViz {...props} />;
  if (kind === 'briefing') return <BriefingViz {...props} />;
  return <ChipMatrixViz {...props} layout={kind === 'swot' ? SWOT_LAYOUT : TOWS_LAYOUT} />;
}
